import { Injectable } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class AppPaginatorIntl extends MatPaginatorIntl {
  firstPageLabel = $localize`:@@ttcMatPaginator.firstPageLabel:First page`;
  itemsPerPageLabel = $localize`:@@ttcMatPaginator.itemsPerPageLabel:Items per page:`;
  lastPageLabel = $localize`:@@ttcMatPaginator.lastPageLabel:Last page`;
  nextPageLabel = $localize`:@@ttcMatPaginator.nextPageLabel:Next page`;
  previousPageLabel = $localize`:@@ttcMatPaginator.previousPageLabel:Previous page`;

  getRangeLabel = function (
    page: number,
    pageSize: number,
    length: number,
  ): string {
    if (0 === length || 0 === pageSize) {
      return $localize`:@@ttcMatPaginator.noContentLabel:0 of ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return $localize`:@@ttcMatPaginator.pageContentLabel:${
      startIndex + 1
    } – ${endIndex} of ${length}`;
  };
}
